import { Injectable } from '@angular/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import config from 'capacitor.config';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  async initialize() {
    await SocialLogin.initialize({
      google: {
        webClientId: config.plugins.SocialLogin.google.webClientId, // Use Web Client ID for all platforms
        iOSClientId: config.plugins.SocialLogin.google.iOSClientId, // for iOS
        mode: 'online',
      },
    });
  }

  async signInWithGoogle() {
    return SocialLogin.login({
      provider: 'google',
      options: {
        scopes: ['email', 'profile'],
        forceRefreshToken: true, // if you need refresh token
        forcePrompt: true,
      },
    });
  }
}
